# frozen_string_literal: true

require_relative 'buy_shares'

module Engine
  module Action
    class CorporateBuyShares < BuyShares
    end
  end
end
